// This content is printed in the Homepage Slider
const one = 'https://lumiere-a.akamaihd.net/v1/images/roj40-hero-desktop_82ea35b1.jpeg'

const overOne = 'https://lumiere-a.akamaihd.net/v1/images/roj40-logotitle-800-500_19fb096e.png'

const two = 'https://lumiere-a.akamaihd.net/v1/images/quiz-rotj-sw2-hero-desktop_be2dd6d5.jpeg'

const three = 'https://lumiere-a.akamaihd.net/v1/images/carrie-fisher-wof-hero-desktop_ba42f837.jpeg'

const four = 'https://lumiere-a.akamaihd.net/v1/images/rise-of-the-red-blade_sashsingle-hero-desktop_ac3778f0.jpeg'

const five = 'https://lumiere-a.akamaihd.net/v1/images/leandre-interview-sashsingle-hero-desktop_5f548dff.jpeg'

const titleOne = 'https://lumiere-a.akamaihd.net/v1/images/roj40-logotitle-800-500_19fb096e.png'
const subtitleOne = 'We celebrate the 40th anniversary of Star Wars: Return of the Jedi!'

const titleTwo = 'Jedi at 40 | How Well Do You Know Star Wars: Return of the Jedi'
const subtitleTwo = 'Test your knowledge of this fan-favorite movie.'

const titleThree = 'The Clone Wars Ignite in Inquisitor: Rise of the Red Blade — Exclusive First Excerpt'
const subtitleThree = 'Iskat Akaris finds herself on the brink of war as she arrives on Geonosis before the battle breaks out.'


const titleFour = 'This Star Wars Day, Carrie Fisher Honored with Star on Hollywood Walk of Fame'
const subtitleFour = 'To us, she is royalty.'

const titleFive = "Lucasfilm's LeAndre Thomas On His Journey to Direct 'The Pit'"
const subtitleFive = 'The filmmaker discusses fulfilling a dream with his new short, featured in Star Wars: Visions Volume 2.'

export { one, overOne, two, three, four, five, titleOne, subtitleOne, titleTwo,  subtitleTwo,titleThree, subtitleThree, titleFour, subtitleFour,titleFive, subtitleFive }